import {
    IndexTable,
    useIndexResourceState,
    Button,
} from '@shopify/polaris';
import React from 'react';
import Language from '../../../../i18n/Language';
import utils from '../../../../utils/utils';
const t = Language;

const HistoryTable = (props) => {
    const {
        tableList,
        openUrlDetail,

    } = props;
    
    const resourceName = {
        singular: 'data',
        plural: 'datas',
    };

    const { selectedResources, allResourcesSelected, handleSelectionChange } =
        useIndexResourceState(tableList);

    const rowMarkup = tableList.map(
        (
            { id, created_at, type, num, status, urlArr },
            index,
        ) => (
            <IndexTable.Row
                id={id}
                key={id}
                selected={selectedResources.includes(id)}
                position={index}
            >
                <IndexTable.Cell>{utils.timeFormat(created_at)}</IndexTable.Cell>
                <IndexTable.Cell>{type === 1 ? t("Submit") : t("Delete")}</IndexTable.Cell>
                <IndexTable.Cell>{num}</IndexTable.Cell>
                <IndexTable.Cell>
                    <Button variant='plain' onClick={() => openUrlDetail(urlArr)}>{t("View URL detail")}</Button>
                </IndexTable.Cell>
                <IndexTable.Cell>
                    <span style={{ color: status === 1 ? '#48B467' : '#E32B2B'}}>{status === 1 ? t("Success") : t("Fail")}</span>
                </IndexTable.Cell>
            </IndexTable.Row>
        ),
    );

    return (
        <IndexTable
            resourceName={resourceName}
            itemCount={tableList.length}
            selectedItemsCount={
                allResourcesSelected ? 'All' : selectedResources.length
            }
            onSelectionChange={handleSelectionChange}
            headings={[
                { title: t("Submission Date") },
                { title: t("Submission type") },
                { title: t("Number of submitted URL") },
                { title: t("Submitted URL") },
                { title: t("Submission Status") },
            ]}
            selectable={false}
        >
            {rowMarkup}
        </IndexTable>
    );
}

export default HistoryTable;